import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BookingSection from "@/components/BookingSection";

const BookingPage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="booking-page">
      <Header />
      <main className="pt-20">
        <BookingSection />
      </main>
      <Footer />
    </div>
  );
};

export default BookingPage;
